import { createSelector } from 'reselect'

import { formateSummary } from '../helper'
import {
  setDefaultSource,
  getCountries,
} from '../../../utils/helpers/costcenter'
import { getFilterCountries } from '../../../utils/globalSelectors'

// Create select function to pick off the pieces of state we care about for this calculation
const getQuoteCreateSummarySelector = state =>
  state.corporateQuote.create.summary

const getCommonCostCenterSelector = state => state.common.costcenter
const getCommonCountrySelector = state => state.common.country

// Local Country and cost center for edit report
const getQuoteCreationCostCenterSelector = state =>
  state.corporateQuote.create.costcenter

const getQuoteCreationCountrySelector = state =>
  state.corporateQuote.create.country

const getQuoteCreationCCAndCountryProps = (
  cmcostcenter,
  cmcountry,
  cccostcenter,
  cccountry,
  countries
) => {
  let country = cccountry ? cccountry : cmcountry
  let costcenter = cccostcenter ? cccostcenter : cmcostcenter

  return setDefaultSource(country, costcenter, countries, false)
}

export const getQuoteCreationCCAndCountry = createSelector(
  getCommonCostCenterSelector,
  getCommonCountrySelector,
  getQuoteCreationCostCenterSelector,
  getQuoteCreationCountrySelector,
  getFilterCountries,
  getQuoteCreationCCAndCountryProps
)

export const getQuoteCreateFromattedSummary = createSelector(
  getQuoteCreateSummarySelector, //pick off a piece of state
  quoteSummary => formateSummary(quoteSummary) // last argument is the function that has our select logic -- in our case its pretty simple logic of extracting props.
)



// WEBPACK FOOTER //
// ./src/features/corporate-quote/create/selector.js